var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting_content" }, [
    _c("div", { staticClass: "setting_content_main setting_category" }, [
      _c("form", { on: { change: _vm.logChangeData } }, [
        _c("h2", { staticClass: "setting_content_title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.mailLabelsProperties.TAB_HEADER) +
              "\n      "
          )
        ]),
        _c(
          "div",
          { staticClass: "setting_unit" },
          [
            _c("div", { staticClass: "setting_unit_item customize_unit" }, [
              _c("div", { staticClass: "setting_balloon_rows_label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.mailLabelsProperties.LABEL_FROM_ADDRESS) +
                    "\n            "
                ),
                _c("p", { staticClass: "setting_label" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.screenLabelsProperties.REQUIRE_LABEL) +
                      "\n            "
                  )
                ])
              ]),
              _c("div", { staticClass: "setting_unit_form" }, [
                _c("div", { staticClass: "setting_form_select_wrapper" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.draftMail.user,
                          expression: "draftMail.user"
                        }
                      ],
                      staticClass: "setting_form_select",
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.draftMail,
                              "user",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.validateInputAccount
                        ]
                      }
                    },
                    [
                      _c(
                        "option",
                        {
                          domProps: {
                            value: { id: 0, email: "", isDeleted: false }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.entryLabelProperties.OPTION_SELECT_DEFAULT
                            )
                          )
                        ]
                      ),
                      _vm._l(
                        _vm.users.filter(function(user) {
                          return user.email
                        }),
                        function(user, index) {
                          return _c(
                            "option",
                            {
                              key: index,
                              domProps: {
                                value: {
                                  id: user.id,
                                  email: user.email,
                                  isDeleted: user.isDeleted
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(user.display_name) +
                                  " "
                              ),
                              user && user.isDeleted
                                ? _c(
                                    "span",
                                    {
                                      class:
                                        user && user.isDeleted
                                          ? "item_deleted"
                                          : ""
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.mailMessagesProperties
                                            .ACCOUNT_MAIL_DELETED
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "  <" +
                                  _vm._s(user.email) +
                                  ">\n                "
                              )
                            ]
                          )
                        }
                      )
                    ],
                    2
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "setting_unit_item" }, [
              _c("p", { staticClass: "setting_unit_label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.mailLabelsProperties.AUTO_MAIL_SUBJECT_INPUT_TITLE
                    ) +
                    "\n          "
                )
              ]),
              _c("div", { staticClass: "setting_unit_form" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.draftMail.emailTitle,
                      expression: "draftMail.emailTitle"
                    }
                  ],
                  staticClass: "setting_form_text",
                  attrs: {
                    type: "text",
                    placeholder:
                      _vm.mailLabelsProperties.AUTO_MAIL_SUBJECT_PLACEHOLDER
                  },
                  domProps: { value: _vm.draftMail.emailTitle },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.draftMail,
                          "emailTitle",
                          $event.target.value
                        )
                      },
                      function($event) {
                        return _vm.validateInputSubject()
                      }
                    ]
                  }
                }),
                _c(
                  "h6",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.lengthErrorSubject,
                        expression: "lengthErrorSubject"
                      }
                    ],
                    staticClass: "error-message"
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.mailSettingsProperties.AUTO_MAIL_MAX_LENGTH
                        ) +
                        "\n              " +
                        _vm._s(
                          _vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE
                        ) +
                        "\n            "
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "entry_mail_setting" }, [
              _c("p", { staticClass: "setting_unit_title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.mailLabelsProperties.ENTRY_AUTO_MAIL_HEADER) +
                    "\n          "
                )
              ]),
              _c("p", { staticClass: "setting_unit_explain" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.mailLabelsProperties.ENTRY_AUTO_MAIL_SUB_HEADER
                    ) +
                    "\n          "
                )
              ]),
              _c("div", { staticClass: "setting_unit_item" }, [
                _c("p", { staticClass: "setting_unit_label" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.mailLabelsProperties
                          .ENTRY_AUTO_MAIL_BODY_INPUT_TITLE
                      ) +
                      "\n            "
                  )
                ]),
                _c("div", { staticClass: "setting_unit_form" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.draftMail.emailBody,
                        expression: "draftMail.emailBody"
                      }
                    ],
                    staticClass: "setting_form_textarea",
                    attrs: {
                      placeholder:
                        _vm.mailLabelsProperties
                          .ENTRY_AUTO_MAIL_BODY_PLACEHOLDER
                    },
                    domProps: { value: _vm.draftMail.emailBody },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.draftMail,
                            "emailBody",
                            $event.target.value
                          )
                        },
                        function($event) {
                          return _vm.validateInputBodyMail()
                        }
                      ]
                    }
                  }),
                  _c(
                    "h6",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.lengthErrorBodyMail,
                          expression: "lengthErrorBodyMail"
                        }
                      ],
                      staticClass: "error-message"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.mailSettingsProperties.BODY_MAIL_MAX_LENGTH
                          ) +
                          "\n                " +
                          _vm._s(
                            _vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE
                          ) +
                          "\n              "
                      )
                    ]
                  )
                ])
              ]),
              _c("div", { staticClass: "setting_unit" }, [
                _c("p", { staticClass: "setting_unit_title" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.mailLabelsProperties.ENTRY_LABEL_REPLACE_MAIL_HEADER
                      ) +
                      "\n            "
                  )
                ]),
                _c("p", { staticClass: "setting_unit_explain" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.mailLabelsProperties
                          .ENTRY_LABEL_REPLACE_MAIL_SUB_HEADER
                      ) +
                      "\n            "
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass: "setting_mail_input_replace d-flex flex-wrap"
                  },
                  [
                    _c("p", { staticClass: "setting_unit_label_customize" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.mailLabelsProperties.LABEL_MAIL_INPUT_TEXT_TITLE
                          ) +
                          "\n              "
                      )
                    ]),
                    _c("p", { staticClass: "setting_unit_label" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.mailLabelsProperties.LABEL_MAIL_INPUT_ITEM_TITLE
                          ) +
                          "\n              "
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "setting_unit_form" },
                  [
                    _vm._l(_vm.computedMailReplace, function(
                      mailReplace,
                      indexMail
                    ) {
                      return _c("div", { key: indexMail }, [
                        _c(
                          "div",
                          { staticClass: "setting_form_wrapper mt-2" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: mailReplace.keyReplace,
                                  expression: "mailReplace.keyReplace"
                                }
                              ],
                              staticClass:
                                "setting_form_text setting_key_replace mr-2",
                              attrs: {
                                type: "text",
                                placeholder:
                                  _vm.mailLabelsProperties
                                    .LABEL_REPLACE_KEY_PLACEHOLDER
                              },
                              domProps: { value: mailReplace.keyReplace },
                              on: {
                                input: [
                                  function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      mailReplace,
                                      "keyReplace",
                                      $event.target.value
                                    )
                                  },
                                  function($event) {
                                    return _vm.validateInputReplaceKey(
                                      _vm.ITEM_ENTRY
                                    )
                                  }
                                ]
                              }
                            }),
                            _c(
                              "draggable",
                              {
                                staticClass: "setting_draagle_item",
                                attrs: {
                                  list: mailReplace.itemReplaces,
                                  draggable: ".item",
                                  group: {
                                    name: "item-job-or-candidate",
                                    put:
                                      _vm.checkSettingsLength(
                                        indexMail,
                                        _vm.ITEM_ENTRY
                                      ) === 0
                                  }
                                },
                                on: {
                                  add: function($event) {
                                    return _vm.addItemToMailReplace(
                                      indexMail,
                                      _vm.ITEM_ENTRY
                                    )
                                  }
                                }
                              },
                              [
                                _vm._l(mailReplace.itemReplaces, function(
                                  mailReplace,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "item" },
                                    [
                                      mailReplace
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "setting_form_wrapper"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      mailReplace.display_name,
                                                    expression:
                                                      "mailReplace.display_name"
                                                  }
                                                ],
                                                staticClass:
                                                  "setting_form_text",
                                                attrs: {
                                                  type: "text",
                                                  placeholder:
                                                    _vm.mailLabelsProperties
                                                      .LABEL_MAIL_REPLACE_PLACEHOLDER,
                                                  readonly: ""
                                                },
                                                domProps: {
                                                  value:
                                                    mailReplace.display_name
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      mailReplace,
                                                      "display_name",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "setting_form_wrapper_close",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deleteItemMailReplace(
                                                        indexMail,
                                                        _vm.ITEM_ENTRY,
                                                        mailReplace
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        width: "12",
                                                        height: "12",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "g",
                                                        {
                                                          attrs: {
                                                            fill: "none",
                                                            "fill-rule":
                                                              "evenodd"
                                                          }
                                                        },
                                                        [
                                                          _c("rect", {
                                                            attrs: {
                                                              fill: "#555",
                                                              width: "12",
                                                              height: "12",
                                                              rx: "2"
                                                            }
                                                          }),
                                                          _c(
                                                            "g",
                                                            {
                                                              attrs: {
                                                                fill: "#FFF"
                                                              }
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  d:
                                                                    "M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                                                }
                                                              }),
                                                              _c("path", {
                                                                attrs: {
                                                                  d:
                                                                    "M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                _vm.checkSettingsLength(
                                  indexMail,
                                  _vm.ITEM_ENTRY
                                ) === 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "setting_form_wrapper",
                                        attrs: { slot: "footer" },
                                        slot: "footer"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: mailReplace.display_name,
                                              expression:
                                                "mailReplace.display_name"
                                            }
                                          ],
                                          staticClass: "setting_form_text",
                                          attrs: {
                                            type: "text",
                                            placeholder:
                                              _vm.mailLabelsProperties
                                                .LABEL_MAIL_REPLACE_PLACEHOLDER,
                                            readonly: ""
                                          },
                                          domProps: {
                                            value: mailReplace.display_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                mailReplace,
                                                "display_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            ),
                            indexMail >= 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "setting_form_wrapper_delete",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeEmailReplace(
                                          indexMail,
                                          _vm.ITEM_ENTRY,
                                          mailReplace
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "12",
                                          height: "12",
                                          xmlns: "http://www.w3.org/2000/svg"
                                        }
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              fill: "#AAA",
                                              "fill-rule": "evenodd"
                                            }
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M.255 1.545l.99-.99 9.9 9.9-.99.99z"
                                              }
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M10.155.555l.99.99-9.9 9.9-.99-.99z"
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.lengthErrorReplaceKeys.includes(
                                  indexMail
                                ),
                                expression:
                                  "lengthErrorReplaceKeys.includes(indexMail)"
                              }
                            ],
                            staticClass: "error-message clearfix"
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.mailSettingsProperties
                                    .KEY_REPLACE_MAX_LENGTH
                                ) +
                                "\n                  " +
                                _vm._s(
                                  _vm.errorProperties
                                    .MAX_LENGTH_CHARACTER_MESSAGE
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.formatErrorReplaceKeys.includes(
                                  indexMail
                                ),
                                expression:
                                  "formatErrorReplaceKeys.includes(indexMail)"
                              }
                            ],
                            staticClass: "error-message clearfix"
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.mailMessagesProperties
                                    .KEY_REPLACE_WRONG_FORMAT
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ])
                    }),
                    _c("div", { staticClass: "setting_unit_add" }, [
                      _c(
                        "div",
                        {
                          staticClass: "setting_unit_add_btn",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addEmailReplace(_vm.ITEM_ENTRY)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.mailLabelsProperties.LABEL_ADD_MAIL_REPLACE
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._l(_vm.keyDuplicates, function(keyDuplicate, index) {
                      return _c("div", { key: index }, [
                        keyDuplicate && keyDuplicate.length > 1
                          ? _c("p", { staticClass: "error-message" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.mailMessagesProperties
                                      .MESSAGE_DUPLICATE_KEY_START
                                  ) +
                                  "\n                  " +
                                  _vm._s(keyDuplicate) +
                                  "\n                  " +
                                  _vm._s(
                                    _vm.mailMessagesProperties
                                      .MESSAGE_DUPLICATE_KEY_END
                                  ) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ])
                    })
                  ],
                  2
                )
              ])
            ]),
            _vm.hp_renkei_job === 1
              ? [
                  _c("div", { staticClass: "job_mail_setting" }, [
                    _c("p", { staticClass: "setting_unit_title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.mailLabelsProperties.JOB_AUTO_MAIL_HEADER
                          ) +
                          "\n          "
                      )
                    ]),
                    _c("p", { staticClass: "setting_unit_explain" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.mailLabelsProperties.JOB_AUTO_MAIL_SUB_HEADER
                          ) +
                          "\n          "
                      )
                    ]),
                    _c("div", { staticClass: "setting_unit_item" }, [
                      _c("p", { staticClass: "setting_unit_label" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.mailLabelsProperties
                                .JOB_AUTO_MAIL_BODY_INPUT_TITLE
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("div", { staticClass: "setting_unit_form" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.draftMail.emailBodyJob,
                              expression: "draftMail.emailBodyJob"
                            }
                          ],
                          staticClass: "setting_form_textarea",
                          attrs: {
                            placeholder:
                              _vm.mailLabelsProperties
                                .JOB_AUTO_MAIL_BODY_PLACEHOLDER
                          },
                          domProps: { value: _vm.draftMail.emailBodyJob },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.draftMail,
                                  "emailBodyJob",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                _vm.validateInputBodyMailJob()
                                _vm.checkEmptyForm()
                              }
                            ]
                          }
                        }),
                        _c(
                          "h6",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.lengthErrorBodyMailJob,
                                expression: "lengthErrorBodyMailJob"
                              }
                            ],
                            staticClass: "error-message"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.mailSettingsProperties
                                    .BODY_MAIL_MAX_LENGTH
                                ) +
                                "\n                " +
                                _vm._s(
                                  _vm.errorProperties
                                    .MAX_LENGTH_CHARACTER_MESSAGE
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _c(
                          "h6",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.isExistJobFormError &&
                                  _vm.draftMail.emailBodyJob.length !== 0,
                                expression:
                                  "isExistJobFormError && draftMail.emailBodyJob.length !== 0"
                              }
                            ],
                            staticClass: "error-message"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.errorProperties.BODY_MAIL_EMPTY_JOB_FORM
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "setting_unit" }, [
                      _c("p", { staticClass: "setting_unit_title" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.mailLabelsProperties
                                .JOB_LABEL_REPLACE_MAIL_HEADER
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("p", { staticClass: "setting_unit_explain" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.mailLabelsProperties
                                .JOB_LABEL_REPLACE_MAIL_SUB_HEADER
                            ) +
                            "\n            "
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "setting_mail_input_replace d-flex flex-wrap"
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "setting_unit_label_customize" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.mailLabelsProperties
                                      .LABEL_MAIL_INPUT_TEXT_TITLE
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _c("p", { staticClass: "setting_unit_label" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.mailLabelsProperties
                                    .LABEL_MAIL_INPUT_ITEM_TITLE
                                ) +
                                "\n              "
                            )
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "setting_unit_form" },
                        [
                          _vm._l(_vm.computedMailReplaceJob, function(
                            mailReplace,
                            indexMail
                          ) {
                            return _c("div", { key: indexMail }, [
                              _c(
                                "div",
                                { staticClass: "setting_form_wrapper mt-2" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: mailReplace.keyReplace,
                                        expression: "mailReplace.keyReplace"
                                      }
                                    ],
                                    staticClass:
                                      "setting_form_text setting_key_replace mr-2",
                                    attrs: {
                                      type: "text",
                                      placeholder:
                                        _vm.mailLabelsProperties
                                          .LABEL_REPLACE_KEY_PLACEHOLDER
                                    },
                                    domProps: { value: mailReplace.keyReplace },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            mailReplace,
                                            "keyReplace",
                                            $event.target.value
                                          )
                                        },
                                        function($event) {
                                          return _vm.validateInputReplaceKey(
                                            _vm.ITEM_JOB
                                          )
                                        }
                                      ]
                                    }
                                  }),
                                  _c(
                                    "draggable",
                                    {
                                      staticClass: "setting_draagle_item",
                                      attrs: {
                                        list: mailReplace.itemReplaces,
                                        draggable: ".item",
                                        group: {
                                          name: "item-job-or-candidate",
                                          put:
                                            _vm.checkSettingsLength(
                                              indexMail,
                                              _vm.ITEM_JOB
                                            ) === 0
                                        }
                                      },
                                      on: {
                                        add: function($event) {
                                          return _vm.addItemToMailReplace(
                                            indexMail,
                                            _vm.ITEM_JOB
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._l(mailReplace.itemReplaces, function(
                                        mailReplace,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: index, staticClass: "item" },
                                          [
                                            mailReplace
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "setting_form_wrapper"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            mailReplace.display_name,
                                                          expression:
                                                            "mailReplace.display_name"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "setting_form_text",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder:
                                                          _vm
                                                            .mailLabelsProperties
                                                            .LABEL_MAIL_REPLACE_PLACEHOLDER,
                                                        readonly: ""
                                                      },
                                                      domProps: {
                                                        value:
                                                          mailReplace.display_name
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            mailReplace,
                                                            "display_name",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "setting_form_wrapper_close",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.deleteItemMailReplace(
                                                              indexMail,
                                                              _vm.ITEM_JOB,
                                                              mailReplace
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              width: "12",
                                                              height: "12",
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "g",
                                                              {
                                                                attrs: {
                                                                  fill: "none",
                                                                  "fill-rule":
                                                                    "evenodd"
                                                                }
                                                              },
                                                              [
                                                                _c("rect", {
                                                                  attrs: {
                                                                    fill:
                                                                      "#555",
                                                                    width: "12",
                                                                    height:
                                                                      "12",
                                                                    rx: "2"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "g",
                                                                  {
                                                                    attrs: {
                                                                      fill:
                                                                        "#FFF"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d:
                                                                          "M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                                                      }
                                                                    }),
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d:
                                                                          "M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm.checkSettingsLength(
                                        indexMail,
                                        _vm.ITEM_JOB
                                      ) === 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "setting_form_wrapper",
                                              attrs: { slot: "footer" },
                                              slot: "footer"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      mailReplace.display_name,
                                                    expression:
                                                      "mailReplace.display_name"
                                                  }
                                                ],
                                                staticClass:
                                                  "setting_form_text",
                                                attrs: {
                                                  type: "text",
                                                  placeholder:
                                                    _vm.mailLabelsProperties
                                                      .LABEL_MAIL_REPLACE_PLACEHOLDER,
                                                  readonly: ""
                                                },
                                                domProps: {
                                                  value:
                                                    mailReplace.display_name
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      mailReplace,
                                                      "display_name",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  indexMail >= 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "setting_form_wrapper_delete",
                                          on: {
                                            click: function($event) {
                                              return _vm.removeEmailReplace(
                                                indexMail,
                                                _vm.ITEM_JOB,
                                                mailReplace
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "12",
                                                height: "12",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg"
                                              }
                                            },
                                            [
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    fill: "#AAA",
                                                    "fill-rule": "evenodd"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M.255 1.545l.99-.99 9.9 9.9-.99.99z"
                                                    }
                                                  }),
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M10.155.555l.99.99-9.9 9.9-.99-.99z"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.lengthErrorReplaceKeysJob.includes(
                                        indexMail
                                      ),
                                      expression:
                                        "lengthErrorReplaceKeysJob.includes(indexMail)"
                                    }
                                  ],
                                  staticClass: "error-message clearfix"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.mailSettingsProperties
                                          .KEY_REPLACE_MAX_LENGTH
                                      ) +
                                      "\n                  " +
                                      _vm._s(
                                        _vm.errorProperties
                                          .MAX_LENGTH_CHARACTER_MESSAGE
                                      ) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.formatErrorReplaceKeysJob.includes(
                                        indexMail
                                      ),
                                      expression:
                                        "formatErrorReplaceKeysJob.includes(indexMail)"
                                    }
                                  ],
                                  staticClass: "error-message clearfix"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.mailMessagesProperties
                                          .KEY_REPLACE_WRONG_FORMAT
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          }),
                          _c("div", { staticClass: "setting_unit_add" }, [
                            _c(
                              "div",
                              {
                                staticClass: "setting_unit_add_btn",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.addEmailReplace(_vm.ITEM_JOB)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.mailLabelsProperties
                                        .LABEL_ADD_MAIL_REPLACE
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._l(_vm.keyDuplicatesJob, function(
                            keyDuplicate,
                            index
                          ) {
                            return _c("div", { key: index }, [
                              keyDuplicate && keyDuplicate.length > 1
                                ? _c("p", { staticClass: "error-message" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.mailMessagesProperties
                                            .MESSAGE_DUPLICATE_KEY_START
                                        ) +
                                        "\n                  " +
                                        _vm._s(keyDuplicate) +
                                        "\n                  " +
                                        _vm._s(
                                          _vm.mailMessagesProperties
                                            .MESSAGE_DUPLICATE_KEY_END
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          })
                        ],
                        2
                      )
                    ])
                  ])
                ]
              : _vm._e(),
            _vm.hp_renkei_job === 1 && _vm.is_plan_dispatch_basic === 1
              ? [
                  _c("div", { staticClass: "dispatch_job_setting" }, [
                    _c("p", { staticClass: "setting_unit_title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.mailLabelsProperties
                              .DISPATCH_JOB_AUTO_MAIL_HEADER
                          ) +
                          "\n          "
                      )
                    ]),
                    _c("p", { staticClass: "setting_unit_explain" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.mailLabelsProperties
                              .DISPATCH_JOB_AUTO_MAIL_SUB_HEADER
                          ) +
                          "\n          "
                      )
                    ]),
                    _c("div", { staticClass: "setting_unit_item" }, [
                      _c("p", { staticClass: "setting_unit_label" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.mailLabelsProperties
                                .DISPATCH_JOB_AUTO_MAIL_BODY_INPUT_TITLE
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("div", { staticClass: "setting_unit_form" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.draftMail.emailBodyDispatch,
                              expression: "draftMail.emailBodyDispatch"
                            }
                          ],
                          staticClass: "setting_form_textarea",
                          attrs: {
                            placeholder:
                              _vm.mailLabelsProperties
                                .DISPATCH_JOB_AUTO_MAIL_BODY_PLACEHOLDER
                          },
                          domProps: { value: _vm.draftMail.emailBodyDispatch },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.draftMail,
                                  "emailBodyDispatch",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                _vm.validateInputBodyMailDispatch()
                                _vm.checkEmptyForm()
                              }
                            ]
                          }
                        }),
                        _c(
                          "h6",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.lengthErrorBodyMailDispatch,
                                expression: "lengthErrorBodyMailDispatch"
                              }
                            ],
                            staticClass: "error-message"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.mailSettingsProperties
                                    .BODY_MAIL_MAX_LENGTH
                                ) +
                                "\n                " +
                                _vm._s(
                                  _vm.errorProperties
                                    .MAX_LENGTH_CHARACTER_MESSAGE
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _c(
                          "h6",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.isExistDispatchFormError &&
                                  _vm.draftMail.emailBodyDispatch.length !== 0,
                                expression:
                                  "isExistDispatchFormError && draftMail.emailBodyDispatch.length !== 0"
                              }
                            ],
                            staticClass: "error-message"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.errorProperties
                                    .BODY_MAIL_EMPTY_DISPATCH_JOB_FORM
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "setting_unit" }, [
                      _c("p", { staticClass: "setting_unit_title" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.mailLabelsProperties
                                .DISPATCH_JOB_LABEL_REPLACE_MAIL_HEADER
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("p", { staticClass: "setting_unit_explain" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.mailLabelsProperties
                                .DISPATCH_JOB_LABEL_REPLACE_MAIL_SUB_HEADER
                            ) +
                            "\n            "
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "setting_mail_input_replace d-flex flex-wrap"
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "setting_unit_label_customize" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.mailLabelsProperties
                                      .LABEL_MAIL_INPUT_TEXT_TITLE
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _c("p", { staticClass: "setting_unit_label" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.mailLabelsProperties
                                    .LABEL_MAIL_INPUT_ITEM_TITLE
                                ) +
                                "\n              "
                            )
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "setting_unit_form" },
                        [
                          _vm._l(_vm.computedMailReplaceDispatch, function(
                            mailReplace,
                            indexMail
                          ) {
                            return _c("div", { key: indexMail }, [
                              _c(
                                "div",
                                { staticClass: "setting_form_wrapper mt-2" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: mailReplace.keyReplace,
                                        expression: "mailReplace.keyReplace"
                                      }
                                    ],
                                    staticClass:
                                      "setting_form_text setting_key_replace mr-2",
                                    attrs: {
                                      type: "text",
                                      placeholder:
                                        _vm.mailLabelsProperties
                                          .LABEL_REPLACE_KEY_PLACEHOLDER
                                    },
                                    domProps: { value: mailReplace.keyReplace },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            mailReplace,
                                            "keyReplace",
                                            $event.target.value
                                          )
                                        },
                                        function($event) {
                                          return _vm.validateInputReplaceKey(
                                            _vm.ITEM_DISPATCH_JOB
                                          )
                                        }
                                      ]
                                    }
                                  }),
                                  _c(
                                    "draggable",
                                    {
                                      staticClass: "setting_draagle_item",
                                      attrs: {
                                        list: mailReplace.itemReplaces,
                                        draggable: ".item",
                                        group: {
                                          name: "item-job-or-candidate",
                                          put:
                                            _vm.checkSettingsLength(
                                              indexMail,
                                              _vm.ITEM_DISPATCH_JOB
                                            ) === 0
                                        }
                                      },
                                      on: {
                                        add: function($event) {
                                          return _vm.addItemToMailReplace(
                                            indexMail,
                                            _vm.ITEM_DISPATCH_JOB
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._l(mailReplace.itemReplaces, function(
                                        mailReplace,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: index, staticClass: "item" },
                                          [
                                            mailReplace
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "setting_form_wrapper"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            mailReplace.display_name,
                                                          expression:
                                                            "mailReplace.display_name"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "setting_form_text",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder:
                                                          _vm
                                                            .mailLabelsProperties
                                                            .LABEL_MAIL_REPLACE_PLACEHOLDER,
                                                        readonly: ""
                                                      },
                                                      domProps: {
                                                        value:
                                                          mailReplace.display_name
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            mailReplace,
                                                            "display_name",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "setting_form_wrapper_close",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.deleteItemMailReplace(
                                                              indexMail,
                                                              _vm.ITEM_DISPATCH_JOB,
                                                              mailReplace
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              width: "12",
                                                              height: "12",
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "g",
                                                              {
                                                                attrs: {
                                                                  fill: "none",
                                                                  "fill-rule":
                                                                    "evenodd"
                                                                }
                                                              },
                                                              [
                                                                _c("rect", {
                                                                  attrs: {
                                                                    fill:
                                                                      "#555",
                                                                    width: "12",
                                                                    height:
                                                                      "12",
                                                                    rx: "2"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "g",
                                                                  {
                                                                    attrs: {
                                                                      fill:
                                                                        "#FFF"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d:
                                                                          "M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                                                      }
                                                                    }),
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d:
                                                                          "M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm.checkSettingsLength(
                                        indexMail,
                                        _vm.ITEM_DISPATCH_JOB
                                      ) === 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "setting_form_wrapper",
                                              attrs: { slot: "footer" },
                                              slot: "footer"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      mailReplace.display_name,
                                                    expression:
                                                      "mailReplace.display_name"
                                                  }
                                                ],
                                                staticClass:
                                                  "setting_form_text",
                                                attrs: {
                                                  type: "text",
                                                  placeholder:
                                                    _vm.mailLabelsProperties
                                                      .LABEL_MAIL_REPLACE_PLACEHOLDER,
                                                  readonly: ""
                                                },
                                                domProps: {
                                                  value:
                                                    mailReplace.display_name
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      mailReplace,
                                                      "display_name",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  indexMail >= 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "setting_form_wrapper_delete",
                                          on: {
                                            click: function($event) {
                                              return _vm.removeEmailReplace(
                                                indexMail,
                                                _vm.ITEM_DISPATCH_JOB,
                                                mailReplace
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "12",
                                                height: "12",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg"
                                              }
                                            },
                                            [
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    fill: "#AAA",
                                                    "fill-rule": "evenodd"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M.255 1.545l.99-.99 9.9 9.9-.99.99z"
                                                    }
                                                  }),
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M10.155.555l.99.99-9.9 9.9-.99-.99z"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.lengthErrorReplaceKeysDispatch.includes(
                                        indexMail
                                      ),
                                      expression:
                                        "lengthErrorReplaceKeysDispatch.includes(indexMail)"
                                    }
                                  ],
                                  staticClass: "error-message clearfix"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.mailSettingsProperties
                                          .KEY_REPLACE_MAX_LENGTH
                                      ) +
                                      "\n                  " +
                                      _vm._s(
                                        _vm.errorProperties
                                          .MAX_LENGTH_CHARACTER_MESSAGE
                                      ) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.formatErrorReplaceKeysDispatch.includes(
                                        indexMail
                                      ),
                                      expression:
                                        "formatErrorReplaceKeysDispatch.includes(indexMail)"
                                    }
                                  ],
                                  staticClass: "error-message clearfix"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.mailMessagesProperties
                                          .KEY_REPLACE_WRONG_FORMAT
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          }),
                          _c("div", { staticClass: "setting_unit_add" }, [
                            _c(
                              "div",
                              {
                                staticClass: "setting_unit_add_btn",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.addEmailReplace(
                                      _vm.ITEM_DISPATCH_JOB
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.mailLabelsProperties
                                        .LABEL_ADD_MAIL_REPLACE
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._l(_vm.keyDuplicatesDispatch, function(
                            keyDuplicate,
                            index
                          ) {
                            return _c("div", { key: index }, [
                              keyDuplicate && keyDuplicate.length > 1
                                ? _c("p", { staticClass: "error-message" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.mailMessagesProperties
                                            .MESSAGE_DUPLICATE_KEY_START
                                        ) +
                                        "\n                  " +
                                        _vm._s(keyDuplicate) +
                                        "\n                  " +
                                        _vm._s(
                                          _vm.mailMessagesProperties
                                            .MESSAGE_DUPLICATE_KEY_END
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          })
                        ],
                        2
                      )
                    ])
                  ])
                ]
              : _vm._e()
          ],
          2
        ),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.mailLabelsProperties.NOTIFICATION_MAIL_HEADER) +
                "\n        "
            )
          ]),
          _c("p", { staticClass: "setting_unit_explain" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.mailLabelsProperties.NOTIFICATION_MAIL_SUB_HEADER_1)
            ),
            _c("br"),
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm.mailLabelsProperties.NOTIFICATION_MAIL_SUB_HEADER_2
                ) +
                "\n        "
            )
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.mailLabelsProperties.LABEL_MAIL_ENTRY_SUCCESS) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftMail.emailSubject,
                    expression: "draftMail.emailSubject"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder:
                    _vm.mailLabelsProperties.AUTO_MAIL_SUBJECT_PLACEHOLDER
                },
                domProps: { value: _vm.draftMail.emailSubject },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.draftMail,
                        "emailSubject",
                        $event.target.value
                      )
                    },
                    function($event) {
                      return _vm.validateInputEmailSubject()
                    }
                  ]
                }
              }),
              _c(
                "h6",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthErrorEmailSubject,
                      expression: "lengthErrorEmailSubject"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.mailSettingsProperties.AUTO_MAIL_MAX_LENGTH) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.mailLabelsProperties.LABEL_MAIL_ENTRY_ERROR) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftMail.errorEmailTitle,
                    expression: "draftMail.errorEmailTitle"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder:
                    _vm.mailLabelsProperties.AUTO_MAIL_SUBJECT_PLACEHOLDER
                },
                domProps: { value: _vm.draftMail.errorEmailTitle },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.draftMail,
                        "errorEmailTitle",
                        $event.target.value
                      )
                    },
                    function($event) {
                      return _vm.validateInputErrorEmailTitle()
                    }
                  ]
                }
              }),
              _c(
                "h6",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthErrorEmailErrorTitle,
                      expression: "lengthErrorEmailErrorTitle"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.mailSettingsProperties.AUTO_MAIL_MAX_LENGTH) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.mailLabelsProperties.NOTIFICATION_MAIL_INPUT_TITLE
                  ) +
                  "\n          "
              )
            ]),
            _c(
              "div",
              { staticClass: "setting_unit_form" },
              [
                _vm._l(_vm.draftMail.emailAccounts, function(mail, index) {
                  return _c("div", { key: index }, [
                    _c("div", { staticClass: "setting_form_wrapper" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: mail.emailAccount,
                            expression: "mail.emailAccount"
                          }
                        ],
                        staticClass: "setting_form_text mt-2",
                        attrs: {
                          type: "text",
                          placeholder:
                            _vm.mailLabelsProperties
                              .NOTIFICATION_MAIL_PLACEHOLDER
                        },
                        domProps: { value: mail.emailAccount },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                mail,
                                "emailAccount",
                                $event.target.value
                              )
                            },
                            function($event) {
                              return _vm.validateInputEmail()
                            }
                          ]
                        }
                      }),
                      index >= 1
                        ? _c(
                            "div",
                            {
                              staticClass: "setting_form_wrapper_delete",
                              on: {
                                click: function($event) {
                                  return _vm.removeEmail(index)
                                }
                              }
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "12",
                                    height: "12",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        fill: "#AAA",
                                        "fill-rule": "evenodd"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M.255 1.545l.99-.99 9.9 9.9-.99.99z"
                                        }
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M10.155.555l.99.99-9.9 9.9-.99-.99z"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.lengthErrorEmails.includes(index),
                            expression: "lengthErrorEmails.includes(index)"
                          }
                        ],
                        staticClass: "error-message clearfix"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.mailSettingsProperties.MAIL_MAX_LENGTH) +
                            "\n                " +
                            _vm._s(
                              _vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE
                            ) +
                            "\n              "
                        )
                      ]
                    ),
                    _vm.isWrongFormatEmail.includes(index)
                      ? _c("p", { staticClass: "error-message clearfix" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.errorProperties.WRONG_MAIL_FORMAT) +
                              "\n              "
                          )
                        ])
                      : _vm._e()
                  ])
                }),
                _c("div", { staticClass: "setting_unit_add" }, [
                  _vm.draftMail.emailAccounts.length <
                  _vm.mailSettingsProperties.MAX_NUMBER_MAIL
                    ? _c(
                        "a",
                        {
                          staticClass: "setting_unit_add_btn",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addEmail()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.mailLabelsProperties
                                  .ADD_NOTIFICATION_MAIL_LINK
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ],
              2
            )
          ])
        ])
      ])
    ]),
    _c("div", [
      _c(
        "div",
        {
          staticClass: "setting_content_sub",
          attrs: { id: "menu-search-item-mail-tab" }
        },
        [
          _c("div", { staticClass: "setting_human_resource" }, [
            _c("div", { attrs: { id: "entry_heading_search_item_mail" } }, [
              _c(
                "div",
                {
                  staticClass:
                    "setting_options_search d-flex justify-content-end"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "setting_item_display_arrow evt-click",
                      class: _vm.isHideItemEntry ? "" : "is_open",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.hideItemReource(_vm.ITEM_ENTRY)
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "6",
                            height: "6",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M3 0l3 6H0z",
                              fill: "#333",
                              "fill-rule": "evenodd"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "setting_btn_secondary setting_btn_medium",
                      on: { click: _vm.refreshResourceList }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.screenLabelsProperties.REFRESH_RESOURCE_BUTTON
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _c("div", { staticClass: "setting_options_search" }, [
                _c("p", { staticClass: "setting_options_search_label" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.screenLabelsProperties.SEARCH_LABEL) +
                      "\n            "
                  )
                ]),
                _c("div", { staticClass: "setting_options_search_box" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.computedPropertyHumanResource,
                        expression: "computedPropertyHumanResource"
                      }
                    ],
                    staticClass: "setting_form_text",
                    attrs: {
                      type: "text",
                      placeholder: _vm.screenLabelsProperties.SEARCH_PLACEHOLDER
                    },
                    domProps: { value: _vm.computedPropertyHumanResource },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.getHumanResourceFields($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.computedPropertyHumanResource = $event.target.value
                      }
                    }
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "setting_btn_primary",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.getHumanResourceFields($event)
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "16",
                            height: "16",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c(
                            "g",
                            { attrs: { fill: "none", "fill-rule": "evenodd" } },
                            [
                              _c("circle", {
                                attrs: {
                                  stroke: "#FFF",
                                  "stroke-width": "2",
                                  cx: "6.5",
                                  cy: "6.5",
                                  r: "5.5"
                                }
                              }),
                              _c("path", {
                                attrs: {
                                  fill: "#FFF",
                                  d: "M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "setting_options_search setting_options_search_customize"
                },
                [
                  _c("p", { staticClass: "setting_unit_annotation" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.screenLabelsProperties
                            .ANNOTATION_ITEM_ENTRY_MAIL_SETTING_TAB
                        ) +
                        "\n            "
                    )
                  ])
                ]
              )
            ]),
            _c(
              "div",
              {
                staticClass: "setting_options_wrapper",
                staticStyle: { display: "block" },
                attrs: { id: "entry_item_resource_wrap_mail" }
              },
              [
                _c(
                  "div",
                  { staticClass: "setting_options_category" },
                  _vm._l(_vm.humanCandidateCategories, function(
                    candidateCategory,
                    indexCategory
                  ) {
                    return _c(
                      "div",
                      { key: indexCategory },
                      [
                        _vm.checkEmptyResourceCategory(
                          _vm.computedHumanResourceFields,
                          candidateCategory.name,
                          true
                        ) && candidateCategory.is_display === 1
                          ? [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "setting_options_category_name candidates mt-3"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(candidateCategory.display_name) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _c(
                                "draggable",
                                {
                                  attrs: {
                                    group: {
                                      name: "item-job-or-candidate",
                                      put: false,
                                      pull: "clone"
                                    },
                                    clone: _vm.cloneResource,
                                    sort: false,
                                    list: _vm.computedHumanResourceFields
                                  }
                                },
                                [
                                  _vm._l(
                                    _vm.computedHumanResourceFields,
                                    function(resourceField) {
                                      return [
                                        resourceField.property_category_name ===
                                          candidateCategory.name &&
                                        resourceField.isUsed
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "setting_options_category_item",
                                                on: {
                                                  mousedown: function($event) {
                                                    return _vm.checkAvailableDragDrop(
                                                      "entry"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass:
                                                      "setting_options_category_item_icon",
                                                    attrs: {
                                                      width: "10",
                                                      height: "12",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          fill: "#aaa",
                                                          "fill-rule": "evenodd"
                                                        }
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d:
                                                              "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c("span", {
                                                  staticClass:
                                                    "setting_options_category_item_name",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      resourceField.display_name
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            )
          ]),
          _vm.hp_renkei_job === 1
            ? _c("div", { staticClass: "setting_job_resource" }, [
                _c("div", { attrs: { id: "job_heading_search_item_mail" } }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "setting_options_search_job_resource d-flex justify-content-end"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "setting_item_display_arrow evt-click",
                          class: _vm.isHideItemJob ? "" : "is_open",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.hideItemReource(_vm.ITEM_JOB)
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "6",
                                height: "6",
                                xmlns: "http://www.w3.org/2000/svg"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M3 0l3 6H0z",
                                  fill: "#333",
                                  "fill-rule": "evenodd"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass:
                            "setting_btn_secondary setting_btn_medium",
                          on: { click: _vm.refreshJobResourceList }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.screenLabelsProperties
                                  .REFRESH_RESOURCE_BUTTON
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "setting_options_search_job_resource setting_options_search_customize"
                    },
                    [
                      _c("p", { staticClass: "setting_options_search_label" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.screenLabelsProperties.SEARCH_JOB_LABEL
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("div", { staticClass: "setting_options_search_box" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.computedPropertyJobResource,
                              expression: "computedPropertyJobResource"
                            }
                          ],
                          staticClass: "setting_form_text",
                          attrs: {
                            type: "text",
                            placeholder:
                              _vm.screenLabelsProperties.SEARCH_PLACEHOLDER
                          },
                          domProps: { value: _vm.computedPropertyJobResource },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.getJobResourceFields($event)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.computedPropertyJobResource =
                                $event.target.value
                            }
                          }
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "setting_btn_primary",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.getJobResourceFields($event)
                              }
                            }
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "16",
                                  height: "16",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      fill: "none",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        stroke: "#FFF",
                                        "stroke-width": "2",
                                        cx: "6.5",
                                        cy: "6.5",
                                        r: "5.5"
                                      }
                                    }),
                                    _c("path", {
                                      attrs: {
                                        fill: "#FFF",
                                        d:
                                          "M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass: "setting_options_wrapper",
                    staticStyle: { display: "block" },
                    attrs: { id: "job_item_resource_wrap_mail" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "setting_options_category" },
                      [
                        _vm._l(_vm.jobCategories, function(jobCategory) {
                          return [
                            _vm.checkEmptyResourceCategory(
                              _vm.computedJobResourceFields,
                              jobCategory.name,
                              false
                            ) && jobCategory.is_display === 1
                              ? [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "setting_options_category_name jobs mt-3"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(jobCategory.display_name) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "draggable",
                                    {
                                      attrs: {
                                        group: {
                                          name: "item-job-or-candidate",
                                          put: false,
                                          pull: "clone"
                                        },
                                        clone: _vm.cloneResourceJob,
                                        sort: false,
                                        list: _vm.computedJobResourceFields
                                      }
                                    },
                                    [
                                      _vm._l(
                                        _vm.computedJobResourceFields,
                                        function(resourceField) {
                                          return [
                                            resourceField.property_category_name ===
                                              jobCategory.name &&
                                            resourceField.isUsed &&
                                            !resourceField.isUsedMailTab
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "setting_options_category_item",
                                                    on: {
                                                      mousedown: function(
                                                        $event
                                                      ) {
                                                        return _vm.checkAvailableDragDrop(
                                                          "job"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "setting_options_category_item_icon",
                                                        attrs: {
                                                          width: "10",
                                                          height: "12",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "g",
                                                          {
                                                            attrs: {
                                                              fill: "#aaa",
                                                              "fill-rule":
                                                                "evenodd"
                                                            }
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d:
                                                                  "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _c("span", {
                                                      staticClass:
                                                        "setting_options_category_item_name",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          resourceField.display_name
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ]
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm.hp_renkei_job === 1 && _vm.is_plan_dispatch_basic === 1
            ? _c("div", { staticClass: "setting_job_resource" }, [
                _c(
                  "div",
                  { attrs: { id: "dispatch_job_heading_search_item_mail" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "setting_options_search_job_resource d-flex justify-content-end"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "setting_item_display_arrow evt-click",
                            class: _vm.isHideItemDispatchJob ? "" : "is_open",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.hideItemReource(
                                  _vm.ITEM_DISPATCH_JOB
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "6",
                                  height: "6",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M3 0l3 6H0z",
                                    fill: "#333",
                                    "fill-rule": "evenodd"
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass:
                              "setting_btn_secondary setting_btn_medium",
                            on: { click: _vm.refreshDispatchJobResourceList }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.screenLabelsProperties
                                    .REFRESH_RESOURCE_BUTTON
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "setting_options_search_job_resource setting_options_search_customize"
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "setting_options_search_label" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.screenLabelsProperties
                                    .SEARCH_DISPATCH_JOB_LABEL
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "setting_options_search_box" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.computedPropertyDispatchJobResource,
                                  expression:
                                    "computedPropertyDispatchJobResource"
                                }
                              ],
                              staticClass: "setting_form_text",
                              attrs: {
                                type: "text",
                                placeholder:
                                  _vm.screenLabelsProperties.SEARCH_PLACEHOLDER
                              },
                              domProps: {
                                value: _vm.computedPropertyDispatchJobResource
                              },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.getDispatchJobResourceFields(
                                    $event
                                  )
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.computedPropertyDispatchJobResource =
                                    $event.target.value
                                }
                              }
                            }),
                            _c(
                              "button",
                              {
                                staticClass: "setting_btn_primary",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.getDispatchJobResourceFields(
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          fill: "none",
                                          "fill-rule": "evenodd"
                                        }
                                      },
                                      [
                                        _c("circle", {
                                          attrs: {
                                            stroke: "#FFF",
                                            "stroke-width": "2",
                                            cx: "6.5",
                                            cy: "6.5",
                                            r: "5.5"
                                          }
                                        }),
                                        _c("path", {
                                          attrs: {
                                            fill: "#FFF",
                                            d:
                                              "M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "setting_options_wrapper",
                    staticStyle: { display: "block" },
                    attrs: { id: "dispatch_job_item_resource_wrap_mail" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "setting_options_category" },
                      [
                        _vm._l(_vm.dispatchJobCategories, function(
                          jobCategory
                        ) {
                          return [
                            _vm.checkEmptyResourceCategory(
                              _vm.computedDispatchJobResourceFields,
                              jobCategory.name,
                              false
                            ) && jobCategory.is_display === 1
                              ? [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "setting_options_category_name jobs mt-3"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(jobCategory.display_name) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "draggable",
                                    {
                                      attrs: {
                                        group: {
                                          name: "item-job-or-candidate",
                                          put: false,
                                          pull: "clone"
                                        },
                                        clone: _vm.cloneResourceDispatch,
                                        sort: false,
                                        list:
                                          _vm.computedDispatchJobResourceFields
                                      }
                                    },
                                    [
                                      _vm._l(
                                        _vm.computedDispatchJobResourceFields,
                                        function(resourceField) {
                                          return [
                                            resourceField.property_category_name ===
                                              jobCategory.name &&
                                            resourceField.isUsed &&
                                            !resourceField.isUsedMailTab
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "setting_options_category_item",
                                                    on: {
                                                      mousedown: function(
                                                        $event
                                                      ) {
                                                        return _vm.checkAvailableDragDrop(
                                                          "dispatch"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "setting_options_category_item_icon",
                                                        attrs: {
                                                          width: "10",
                                                          height: "12",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "g",
                                                          {
                                                            attrs: {
                                                              fill: "#aaa",
                                                              "fill-rule":
                                                                "evenodd"
                                                            }
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d:
                                                                  "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _c("span", {
                                                      staticClass:
                                                        "setting_options_category_item_name",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          resourceField.display_name
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ]
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ]
                )
              ])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }